import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalRef } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { Subscription } from 'rxjs';
import { notifyMessage } from '../../../constants/notify-message';
import { PSIDUploadHistoryItem } from '../../operator-settings.interface';
import { OperatorSettingsService } from '../../operator-settings.service';

@Component({
  selector: 'ps-psid-upload-history-modal',
  templateUrl: './psid-upload-history-modal.component.html',
  styleUrls: ['./psid-upload-history-modal.component.css'],
})
export class PsidUploadHistoryModalComponent implements OnInit, OnDestroy {
  psidUploadHistory: PSIDUploadHistoryItem[] = [];
  isPSIDUploadHistoryLoading = false;
  private _subscriptions = new Subscription();

  constructor(
    private _modalRef: ModalRef<PsidUploadHistoryModalComponent, string>,
    private _operatorSettingsService: OperatorSettingsService,
    private _toastr: ToasterService
  ) {}

  ngOnInit(): void {
    this.getPSIDUploadHistory();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  getPSIDUploadHistory() {
    this.isPSIDUploadHistoryLoading = true;
    const history = this._operatorSettingsService
      .getPSIDUploadHistory()
      .subscribe({
        next: (response) => {
          this.psidUploadHistory = response.data || [];
          this.isPSIDUploadHistoryLoading = false;
        },
        error: (err) => {
          this.isPSIDUploadHistoryLoading = false;
          this._toastr.error(
            err.error?.msg || notifyMessage.errorMessage.SERVER_ERROR
          );
        },
      });
    this._subscriptions.add(history);
  }

  close() {
    this._modalRef.close();
  }
}
